export const signupUrl = '/signup';
export const loginUrl = '/login';

// tslint:disable-next-line:no-var-requires
export const isEmailValid = require('validator/lib/isEmail');

export const ANSWERS_BASE_DOMAIN = '.wixanswers.com';

const COOKIE_PREFIX = '_wa';
const ONE_WEEK = 1000 * 3600 * 24 * 7;

export const MARKETING_COOKIE_NAME = `${COOKIE_PREFIX}MID`;
export const CAMPAIGN_COOKIE_NAME = `${COOKIE_PREFIX}CID`;

// tslint:disable-next-line:variable-name
export function setSiteCookies (marketing_id: string, campaign_id: string, req: any, res: any) {
	return new Promise<void>((resolve, _) => {
		const cookieOptions = {maxAge: ONE_WEEK, httpOnly: false, domain: ANSWERS_BASE_DOMAIN};

		const hasNoCookie = (cookieName: string) => {
			return !req.cookies[cookieName];
		};

		if (marketing_id && hasNoCookie(MARKETING_COOKIE_NAME)) {
			res.cookie(MARKETING_COOKIE_NAME, marketing_id, cookieOptions);
		}

		if (campaign_id && hasNoCookie(CAMPAIGN_COOKIE_NAME)) {
			res.cookie(CAMPAIGN_COOKIE_NAME, campaign_id, cookieOptions);
		}

		resolve();
	});
}

export const  getQueryParamByName = (name: string) => {
	const url = location.href;
	name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
	const regexS = '[\\?&]' + name + '=([^&#]*)';
	const regex = new RegExp(regexS);
	const results = regex.exec(url);
	return results === null ? null : results[1];
};

export const getCookieByName = (name: string) => {
	const match = document.cookie.match(new RegExp(name + '=([^;]+)'));
	return match ? match[1] : null;
};
export const checkIfMobile = () => {
	try {
		return window.innerWidth < 768;
	} catch (e) {
		return false;
	}
};

export const isPassValid = (pass: string) => {
	const pattern = /^(?=.*\d+)(?=.*[a-zA-Z]).{6,100}$/;
	return pattern.test(pass);
};
